require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/core-js/fn/object/entries.js
// module id = ../../../../core-js/fn/object/entries.js
// module chunks = vendor